import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/modules/shared.module';
import { MomentModule } from 'ngx-moment'
import { UnsubscribeService } from './unsubscribe.service';
import { UnsubscribeComponent } from './unsubscribe.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
    imports: [
      SharedModule,
      RouterModule,
      NgxMaskModule.forRoot(),
      MomentModule
    ],
    providers: [UnsubscribeService],
    declarations: [
      UnsubscribeComponent
    ]
  })
  export class UnsubscribeModule { }